var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "chat-initiator-template" },
    [
      _vm.loading
        ? _c("md-progress-bar", { attrs: { "md-mode": "indeterminate" } })
        : _vm._e(),
      _vm._v(" "),
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "title" }, [_vm._v("All opt-in numbers.")]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "d-flex justify-content-end w-100" },
        [
          _c("a-pagination", {
            key: Math.random(),
            attrs: {
              size: "small",
              total: _vm.total,
              "show-total": function (total) {
                return "Total " + total + " number"
              },
              "show-size-changer": "",
              "show-quick-jumper": "",
              pageSizeOptions: ["10", "20", "50", "100", "300", "500", "1000"],
              defaultPageSize: _vm.maxResult,
              disabled: _vm.loading,
            },
            on: {
              showSizeChange: function (current, size) {
                return (_vm.maxResult = size)
              },
            },
            model: {
              value: _vm.currentPage,
              callback: function ($$v) {
                _vm.currentPage = $$v
              },
              expression: "currentPage",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c("a-table", {
        attrs: {
          columns: _vm.columns,
          "data-source": _vm.numbers,
          pagination: false,
          "row-key": "id",
          size: "small",
        },
        scopedSlots: _vm._u([
          {
            key: "blocked",
            fn: function (text, record) {
              return _c(
                "span",
                {},
                [
                  _c("a-switch", {
                    staticClass: "md-warning ml-3",
                    attrs: { name: "writing" },
                    on: { change: _vm.$_.noop },
                    model: {
                      value: record.blocked,
                      callback: function ($$v) {
                        _vm.$set(record, "blocked", $$v)
                      },
                      expression: "record.blocked",
                    },
                  }),
                ],
                1
              )
            },
          },
          {
            key: "active",
            fn: function (text, record) {
              return _c(
                "span",
                {},
                [
                  _c("a-switch", {
                    staticClass: "md-warning ml-3",
                    attrs: { name: "writing" },
                    on: { change: _vm.$_.noop },
                    model: {
                      value: record.active,
                      callback: function ($$v) {
                        _vm.$set(record, "active", $$v)
                      },
                      expression: "record.active",
                    },
                  }),
                ],
                1
              )
            },
          },
          {
            key: "lastMessageSentTs",
            fn: function (text, record) {
              return _c("span", {}, [
                _vm._v(
                  "\n            " +
                    _vm._s(
                      _vm
                        .$moment(record.lastMessageSentTs)
                        .format("YYYY-MM-DD HH:mm:ss")
                    ) +
                    "\n        "
                ),
              ])
            },
          },
          {
            key: "options",
            fn: function (text, record) {
              return _c(
                "span",
                {},
                [
                  _c(
                    "a-button",
                    {
                      staticClass: "process-button",
                      on: {
                        click: function () {
                          return _vm.startChat(record.phone)
                        },
                      },
                    },
                    [_vm._v(" Start chat ")]
                  ),
                ],
                1
              )
            },
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "header" }, [
      _c("div", { staticClass: "title" }, [_vm._v("Numbers")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }